import { DiscountCodeStatus } from "@/openapi/generated"

// Single source of truth for the Product Range showcase's "Shops" tab query params.
// ShopsStack (product-range.tsx) and its SSR prefetch (start-server-prefetch.ts) MUST use
// the exact same { size, page } here, or the SSR-prefetched query key won't match the
// client's, silently turning the tab into a client-only fetch (no SSR/SEO, loading flash).
export const PRODUCT_RANGE_SHOPS_PARAMS = { size: 12, page: 0 } as const;

// Same idea for the "Codes" tab. Shared so ProductRangeShowcase's pre-warm call and
// CodesStack produce an identical query key (one deduped fetch). Client-only — codes are
// masked in the DOM, so they are intentionally never SSR-prefetched (would leak in HTML).
export const PRODUCT_RANGE_CODES_PARAMS = { page: 0, size: 12, status: DiscountCodeStatus.ACTIVE } as const;
